export default __webpack_public_path__ + "static/media/img-26-dewin.bb5a12b9.jpg";